import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="flex min-h-screen flex-col items-center justify-center bg-cream px-6 text-center font-sans">
      <p className="font-serif text-7xl text-forest">404</p>
      <h1 className="mt-4 font-serif text-2xl text-slate-900">This page has moved or doesn't exist</h1>
      <p className="mt-3 max-w-md text-sm text-slate-500">
        The property or page you're looking for isn't here — but the rest of the site is.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" data-testid="notfound-home-link" className="rounded-sm bg-forest px-6 py-3 text-sm font-bold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-forest-hover">
          Home
        </Link>
        <Link to="/adani-shantigram" data-testid="notfound-shantigram-link" className="rounded-sm border border-forest/20 px-6 py-3 text-sm font-bold uppercase tracking-widest text-forest transition-colors duration-200 hover:border-gold">
          Adani Shantigram
        </Link>
        <Link to="/contact" data-testid="notfound-contact-link" className="rounded-sm border border-forest/20 px-6 py-3 text-sm font-bold uppercase tracking-widest text-forest transition-colors duration-200 hover:border-gold">
          Contact Us
        </Link>
      </div>
    </main>
  );
}
